'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import PropTypes from 'prop-types';
import { Fragment, useState } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import HR from 'UIComponents/elements/HR';
import UILink from 'UIComponents/link/UILink';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import breakpoint from '../../utils/responsiveBreakpoints';
import UIButton from 'UIComponents/button/UIButton';
import { CALYPSO } from 'HubStyleTokens/colors';
import FeatureModalSplitter from './features/FeatureModalSplitter';
const StyledLink = styled(UILink).withConfig({
  displayName: "ViewAllFeatures__StyledLink",
  componentId: "sc-1i0l2ej-0"
})(["&.features-link{", "}"], breakpoint.phone(_t || (_t = _`
      font-weight: 600;
    `)));
const ViewAllFeaturesContainer = styled.div.withConfig({
  displayName: "ViewAllFeatures__ViewAllFeaturesContainer",
  componentId: "sc-1i0l2ej-1"
})(["text-align:center;hr{background-color:", ";margin-bottom:16px !important;}"], BATTLESHIP);
const FullButton = styled(UIButton).withConfig({
  displayName: "ViewAllFeatures__FullButton",
  componentId: "sc-1i0l2ej-2"
})(["width:100%;height:100%;padding:20px !important;"]);
const StyledMessage = styled(FormattedMessage).withConfig({
  displayName: "ViewAllFeatures__StyledMessage",
  componentId: "sc-1i0l2ej-3"
})(["color:", ";font-weight:600;"], CALYPSO);

const ViewAllFeatures = ({
  productLevel,
  productLine,
  use,
  gaClassName,
  trackingSource
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleViewAllFeaturesModal = () => {
    setIsModalOpen(!isModalOpen);

    if (!isModalOpen) {
      getUsageTracker().track('clickToViewModal', {
        name: 'compare-feature-modal',
        productLine,
        productLevel,
        location: trackingSource
      });
    }
  };

  const ViewAllFeaturesContent = /*#__PURE__*/_jsxs(Fragment, {
    children: [use === 'full' ? /*#__PURE__*/_jsx(FullButton, {
      use: "unstyled",
      onClick: toggleViewAllFeaturesModal,
      children: /*#__PURE__*/_jsx(StyledMessage, {
        message: "pricingPage.highlightedMerchCards.seeAllFeatures",
        className: gaClassName
      })
    }) : /*#__PURE__*/_jsx(StyledLink, {
      className: `m-left-0 features-link ${gaClassName}`,
      onClick: toggleViewAllFeaturesModal,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.highlightedMerchCards.seeAllFeatures",
        className: gaClassName
      })
    }), isModalOpen && /*#__PURE__*/_jsx(FeatureModalSplitter, {
      onCloseClick: toggleViewAllFeaturesModal,
      productLine: productLine,
      defaultProductLevel: productLevel
    })]
  });

  if (use === 'full' || use === 'inline') {
    return ViewAllFeaturesContent;
  }

  return /*#__PURE__*/_jsxs(ViewAllFeaturesContainer, {
    children: [/*#__PURE__*/_jsx(HR, {
      className: "m-bottom-5"
    }), ViewAllFeaturesContent]
  });
};

ViewAllFeatures.propTypes = {
  productLine: PropTypes.string.isRequired,
  productLevel: PropTypes.string,
  gaClassName: PropTypes.string.isRequired,
  use: PropTypes.string,
  trackingSource: PropTypes.string
};
export default ViewAllFeatures;